import {remCalc} from '../../_utils'

const activeLabelStyles = {
    textStyle: 'body-xxsmall',
    transform: `translateY(-${remCalc(20)}) translateX(0)`,
    paddingLeft: '0',
    paddingRight: remCalc(4),
}

export default {
    baseStyle: ({
        shouldRemoveLabel,
        isProductRegistration,
        isInitial,
    }: {
        shouldRemoveLabel: boolean
        isProductRegistration: boolean
        isInitial: boolean
    }) => ({
        container: {
            width: '100%',
            position: 'relative',
            _focusWithin: {
                '&:not(:has(.react-tel-input)) .chakra-form__label': {
                    ...activeLabelStyles,
                    display: shouldRemoveLabel ? 'none' : 'inherit',
                },
            },
            'input:not(:placeholder-shown) ~ .chakra-form__label, .chakra-select__wrapper ~ .chakra-form__label, textarea:not(:placeholder-shown) ~ .chakra-form__label':
                {
                    ...activeLabelStyles,
                    display: shouldRemoveLabel ? 'none' : 'inherit',
                },
            '.react-tel-input': {
                width: '100%',
            },
            '.react-tel-input ~ .chakra-form__label': {
                display: shouldRemoveLabel ? 'none' : 'inherit',
                transform: `translateX(${remCalc(60)})`,
                ...(isInitial ? activeLabelStyles : {}),
            },
            '.react-tel-input:has(input:focus) ~ .chakra-form__label': {
                ...activeLabelStyles,
            },
            '.react-tel-input input': {
                height: remCalc(40),
                textStyle: 'body-xsmall',
                color: 'text.default',
                paddingLeft: remCalc(40),
                paddingRight: remCalc(16),
                width: '100%',
                borderColor: 'border.secondary',
                borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
                borderWidth: remCalc(1),
                outline: 'none',
            },
            '.react-tel-input:has(.flag-dropdown.open) input': {
                borderBottomRadius: ['none'],
                borderBottomColor: 'border.disabled',
            },
            '.react-tel-input .flag-dropdown, .react-tel-input .flag-dropdown.open, .react-tel-input .flag-dropdown.open .selected-flag':
                {
                    border: 0,
                    background: 'none',
                },
            '.react-tel-input .flag-dropdown.open': {
                width: '100%',
            },
            '.react-tel-input .selected-flag, .react-tel-input .selected-flag:hover, .react-tel-input .selected-flag:focus':
                {
                    background: 'none',
                },
            '.react-tel-input .country-list': {
                boxShadow: 'none',
                margin: '-1px 0 0',
                borderColor: 'border.secondary',
                borderBottomRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
                borderWidth: remCalc(1),
                width: '100%',
            },
        },
        label: {
            position: 'absolute',
            top: 0,
            left: 0,
            pointerEvents: 'none',
            transformOrigin: 'left top',
            color: 'text.secondary',
            textStyle: 'body-xsmall',
            // backgroundColor: 'background.default',
            fontWeight: 'normal',
            mx: remCalc(16),
            my: remCalc(13),
            transition: 'transform 0.2s ease',
            _before: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'background.default',
                zIndex: -1,
                transform: 'translateY(57%)',
                paddingRight: remCalc(4),
            },
        },
        input: {
            height: remCalc(40),
            textStyle: 'body-xsmall',
            color: 'text.default',
            borderColor: 'border.secondary',
            paddingLeft: remCalc(16),
            paddingRight: remCalc(16),
            _hover: {
                borderColor: 'border.secondary',
            },
            _focus: {
                borderColor: 'border.secondary',
            },
            _focusVisible: {
                borderColor: 'border.secondary',
            },
            _invalid: {
                borderColor: 'border.danger',
            },
            _disabled: {
                borderColor: 'border.disabled',
                color: 'text.disable',
            },
            _placeholder: {
                fontSize: remCalc(12),
                color: isProductRegistration && 'text.secondary',
            },
        },
        lookupContainerAbs: {
            position: 'absolute',
            width: '100%',
            backgroundColor: 'background.default',
            zIndex: 1,
        },
        lookupContainer: {
            width: '100%',
            position: 'relative',
            _focusWithin: {
                '.chakra-form__label': {...activeLabelStyles},
            },
        },
        lookupInput: {
            height: remCalc(40),
            textStyle: 'body-xsmall',
            color: 'text.default',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
            _hover: {borderColor: 'border.secondary'},
            _focus: {borderColor: 'border.secondary'},
            _focusVisible: {borderColor: 'border.secondary'},
            _invalid: {borderColor: 'border.danger'},
            _disabled: {borderColor: 'border.disabled', color: 'text.disable'},
        },
        lookupInnerContainer: {
            height: remCalc(208),
            overflowY: 'scroll',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.secondary',
        },
        lookupScrollbar: {
            '::-webkit-scrollbar': {
                width: remCalc(7),
                borderRadius: remCalc(13),
                backgroundClip: 'padding-box',
                border: '0.625rem solid transparent',
            },
            '::-webkit-scrollbar-thumb': {
                width: remCalc(16),
                borderRadius: remCalc(13),
                backgroundClip: 'padding-box',
                border: '0.625rem solid transparent',
                boxShadow: 'inset 0 0 0 0.625rem',
                background: 'button.border.inverse-primary-focused',
            },
        },
        lookupHighlight: {
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
        },
        lookupItem: {
            height: remCalc(40),
            alignContent: 'center',
            cursor: 'pointer',
            _hover: {
                backgroundColor: 'background.light',
                color: 'text.default',
                fontWeight: 'bold',
            },
        },
        manualAddressBtnContainer: {
            marginTop: 'xsmall.sm',
        },
        manualAddressBtn: {
            variant: 'text-button',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        textArea: {
            height: remCalc(130),
            padding: remCalc(16),
            textStyle: 'body-xsmall',
            resize: 'none',
            maxLength: '400',
            color: 'text.default',
            borderColor: 'border.secondary',
            fontSize: remCalc(12),
            _hover: {
                borderColor: 'border.secondary',
            },
            _focus: {
                borderColor: 'border.secondary',
            },
            _focusVisible: {
                borderColor: 'border.secondary',
            },
            _invalid: {
                borderColor: 'border.danger',
            },
            _disabled: {
                borderColor: 'border.disabled',
                color: 'text.disable',
            },
        },
        helperText: {
            marginTop: 'xsmall.sm',
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
        },
        errorText: {
            marginTop: 'xsmall.sm',
            textStyle: 'body-xxsmall',
            color: 'text.danger',
        },
        inputRightElement: {
            height: remCalc(40),
            zIndex: 'auto',
        },
        successIcon: {
            boxSize: 'iconsSize.medium',
            color: 'text.success',
        },
        infoIcon: {
            boxSize: 'iconsSize.medium',
            fill: 'button.text.secondary-default',
            color: 'text.default',
            cursor: 'pointer',
        },
        counter: {
            position: 'absolute',
            bottom: remCalc(8),
            right: remCalc(16),
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
        },
    }),
    variants: {
        disabled: {
            label: {color: 'text.disable'},
            container: {
                '.react-tel-input:has(input:focus, input:invalid) ~ .chakra-form__label': {
                    color: 'text.disable',
                },
                'input.iti__tel-input': {
                    borderColor: 'text.disable',
                },
            },
        },
        success: {
            input: {
                borderColor: 'border.success',
                _hover: {borderColor: 'border.success'},
                _focus: {borderColor: 'border.success'},
                _focusVisible: {borderColor: 'border.success'},
            },
            container: {
                '.react-tel-input input': {
                    borderColor: 'border.success',
                },
            },
        },
        invalid: {
            label: {color: 'text.danger'},
            counter: {color: 'text.danger'},
            container: {
                '.react-tel-input:has(input:focus, input:invalid) ~ .chakra-form__label': {
                    color: 'text.danger',
                },
                '.react-tel-input input': {
                    borderColor: 'text.danger',
                },
            },
        },
    },
    parts: [
        'container',
        'label',
        'input',
        'helperText',
        'errorText',
        'counter',
        'inputRightElement',
        'successIcon',
        'infoIcon',
        'textArea',
        'lookupContainer',
        'lookupInput',
        'lookupInnerContainer',
        'lookupItem',
        'lookupHighlight',
        'lookupScrollbar',
        'manualAddressBtnContainer',
        'manualAddressBtn',
    ],
}
